import { formatField } from "../../lib/format";

export const ClientInfo = ({ client }) => (
  <section className="tr-card p-5 sm:p-6" data-testid="client-info">
    <div className="tr-eyebrow mb-1">Datos del cliente</div>
    <h2 className="mb-4 text-base font-bold text-[#182235] md:text-lg">Información del archivo</h2>
    <dl className="grid grid-cols-1 gap-x-4 gap-y-3 sm:grid-cols-2 lg:grid-cols-1">
      {client.fields.map((f) => (
        <div key={f.key} className="min-w-0 border-b border-[#eef2f7] pb-2.5 last:border-0" data-testid={`client-field-${f.key.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
          <dt className="text-xs font-semibold text-[#5b667a]" title={f.hint || f.key} data-testid={`client-label-${f.key.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{f.label}</dt>
          <dd className="break-words text-sm font-semibold text-[#182235]">{formatField(f)}</dd>
        </div>
      ))}
      <div className="min-w-0 pb-1">
        <dt className="text-xs font-semibold text-[#5b667a]">Tipo de persona</dt>
        <dd className="text-sm font-semibold text-[#182235]" data-testid="client-field-tipo-persona">{client.persona_label}</dd>
      </div>
    </dl>
  </section>
);
